export const basePricingXrColumns = [
  'id',
  'r1_id',
  '_cdc_hash',
  '_cdc_seq',
  'account_number',
  'revint_id',
  'xr',
  'adjustment_limit_date',
  'adjustment_limit_second_level_date',
  'age',
  'billing_limit_cob_date',
  'billing_limit_corrected_claim_date',
  'billing_limit_date',
  'contract_effective_from',
  'contract_effective_to',
  'contract_id',
  'contract_master_id',
  'contract_name',
  'created_date',
  'error_message',
  'error_stack_trace',
  'est_nonpursuable_write_off',
  'est_patiability',
  'est_pl_calc_type',
  'est_primary_payment',
  'est_secondary_payment',
  'expected_type',
  'health_system_id',
  'is_recurring_visit',
  'kbox_correlation_id',
  'los',
  'mapping_link_id',
  'modified_date',
  'nonrecurring_pricing_notes',
  'nonrecurring_xr',
  'payer_plan_mapping_id',
  'payer_position',
  'payment_variance',
  'pricing_notes',
  'primary_provision__payment_type',
  'primary_provision__payment_variation',
  'primary_provision__priced_drg',
  'primary_provision__rank',
  'primary_provision__service_id',
  'primary_provision__service_name',
  'primary_provision__service_type',
  'reconsideration_dispute_date',
  'retraction_limit_date',
  'contract_group_name',
  'reporting_payer',
  'parent_payer',
];
